export const FETCH_ARTWORK = 'FETCH_ARTWORK';
export const FETCH_ARTWORK_SUCCESS = 'FETCH_ARTWORK_SUCCESS';
export const FETCH_ARTWORK_FAILURE = 'FETCH_ARTWORK_FAILURE';
export const FETCH_ROARS = 'FETCH_ROARS';
export const FETCH_ROARS_SUCCESS = 'FETCH_ROARS_SUCCESS';
export const FETCH_ROARS_FAILURE = 'FETCH_ROARS_FAILURE';
export const SELECT_ROAR = 'SELECT_ROAR';
export const SELECT_ROAR_SUCCESS = 'SELECT_ROAR_SUCCESS';
export const SELECT_ROAR_FAILURE = 'SELECT_ROAR_FAILURE';
export const SELECT_ARTWORK = 'SELECT_ARTWORK';
export const SELECT_ARTWORK_SUCCESS = 'SELECT_ARTWORK_SUCCESS';
export const SELECT_ARTWORK_FAILURE = 'SELECT_ARTWORK_FAILURE';
export const SAVE_ARTWORK_TO_ROAR = 'SAVE_ARTWORK_TO_ROAR';
export const SELECT_ROAR_AND_SAVE = 'SELECT_ROAR_AND_SAVE';
export const SELECT_ROAR_AND_SAVE_STORE_VALUES = 'SELECT_ROAR_AND_SAVE_STORE_VALUES';



// WEBPACK FOOTER //
// ./src/routes/CreateRoar/StepOne/modules/constants.js